import { useFormikContext } from "formik";
import { useEffect, useRef } from "react";

import { CampaignFormData } from "@/components/screens/CampaignFormPage/types";
import { CampaignType } from "@/types/campaign.types";

type Props = {
  onTypeChange: (type: CampaignType) => void;
};

function CampaignTypeObserver({ onTypeChange }: Props) {
  const { values } = useFormikContext<CampaignFormData>();
  const lastTypeRef = useRef<CampaignType | undefined>(undefined);

  useEffect(() => {
    if (values.type !== undefined && values.type !== lastTypeRef.current) {
      lastTypeRef.current = values.type;
      onTypeChange(values.type);
    }
  }, [values.type, onTypeChange]);

  return null;
}

export default CampaignTypeObserver;
